import React, { PureComponent } from 'react';

import {
  IdTd,
  NameTd,
  AdressTd,
  RequestRow,
  DateTd,
  BaseEllipsisSpan,
  TableOneLineEllipsis,
  PretendentesCellText
} from './table/requestTable.styled';
import RequestTableToolTip from './table/RequestTableToolTip';
import {
  LocacoesRow,
  LocacoesTdId,
  LocacoesTdCodigo,
  LocacoesTdEndereco,
  LocacoesTdPretendentes,
  LocacoesTdData
} from './table/locacoesTablePrimitives.styles';
import moment from 'moment';
import { formatAddress, formatCPF, formatCNPJ } from '../../utils/formatter';

class RequestLine extends PureComponent {

  getApplicantNames = () => {
    const { pretendentes } = this.props;
    if (Array.isArray(pretendentes) && pretendentes.length > 0) {
      return pretendentes.map((applicant) => {
        let nome = applicant.nome || applicant.razao_social
        if(Boolean(applicant.oculto) === true) {
          nome = 'IDENTIFICAÇÃO OCULTADA'
        }
        return nome
      });
    }
    return [];
  }

  getApplicantDocs = () => {
    const { pretendentes } = this.props;
    if (Array.isArray(pretendentes) && pretendentes.length > 0) {
      return pretendentes.map(applicant => {
        if (Boolean(applicant.oculto) === true) {
          return 'OCULTADO';
        }
        if ('documento' in applicant && applicant.documento) {
          if (String(applicant.documento).length === 11) {
            return formatCPF(applicant.documento);
          }
          return formatCNPJ(applicant.documento);
        }
        if ('cpf' in applicant && applicant.cpf) {
          return formatCPF(applicant.cpf);
        }
        if ('cnpj' in applicant && applicant.cnpj) {
          return formatCNPJ(applicant.cnpj);
        }
        return '';
      });
    }
    return [];
  };

  getAdress = () => {
    const { endereco } = this.props;

    if(endereco) {
      return endereco;
    }

    if( Array.isArray(endereco) && endereco.length > 0){
      return `${formatAddress(endereco[0])}`
    }else{
      return "-"
    }
  }

  handleOcultado = (text) => {
    const pretendentes = this.props.pretendentes
    const allOculto = pretendentes.every((pretendente) => Boolean(pretendente.oculto) === true);
    if(allOculto) {
      if(!text) {
        return true;
      }
      if(text === '-') {
        return text;
      }
      return 'OCULTADO';
    }
    return text;
  }

  render() {
    const { modern } = this.props;
    const applicantNames = this.getApplicantNames();
    const adress = this.handleOcultado(this.getAdress());
    const adressStr =
      typeof adress === 'string' ? adress : adress != null ? String(adress) : '';

    const codigoRaw = this.handleOcultado(this.props.codigo_imovel);
    const codigoStr =
      codigoRaw === true || codigoRaw == null ? '' : String(codigoRaw);

    const idStr = String(this.props.id);
    const dateStr = moment(this.props.data_criacao).format('DD/MM/YYYY HH:mm');
    const firstPretendente = applicantNames[0] || '';
    const applicantDocs = this.getApplicantDocs();
    const rowIndex = typeof this.props.index === 'number' ? this.props.index : 0;
    const rowLength = typeof this.props.length === 'number' ? this.props.length : 1;

    const Row = modern ? LocacoesRow : RequestRow;
    const TdId = modern ? LocacoesTdId : IdTd;
    const TdCodigo = modern ? LocacoesTdCodigo : DateTd;
    const TdEndereco = modern ? LocacoesTdEndereco : AdressTd;
    const TdPretendentes = modern ? LocacoesTdPretendentes : NameTd;
    const TdData = modern ? LocacoesTdData : DateTd;

    return (
      <Row onClick={this.props.onGoToResume}>
        <TdId>
          <BaseEllipsisSpan title={idStr}>{idStr}</BaseEllipsisSpan>
        </TdId>
        <TdCodigo>
          <BaseEllipsisSpan title={codigoStr || undefined}>
            {codigoStr}
          </BaseEllipsisSpan>
        </TdCodigo>
        <TdEndereco>
          <TableOneLineEllipsis title={adressStr || undefined}>
            {adressStr}
          </TableOneLineEllipsis>
        </TdEndereco>
        <TdPretendentes>
          {applicantNames.length > 0 ? (
            <RequestTableToolTip
              message={applicantNames}
              extraData={applicantDocs}
              index={rowIndex}
              length={rowLength}
              type="applicantName"
            >
              <PretendentesCellText>{firstPretendente}</PretendentesCellText>
            </RequestTableToolTip>
          ) : (
            <PretendentesCellText />
          )}
        </TdPretendentes>
        <TdData>
          <TableOneLineEllipsis title={dateStr}>{dateStr}</TableOneLineEllipsis>
        </TdData>
      </Row>
    );
  }
}
export default RequestLine;
